import { getTenantLogoUrl } from '../../utils/logoSettings';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicFooter } from '@mts/ui';
import { usePublicTenant } from '../../hooks/usePublicTenant';
import { buildPublicFooterConfig } from '../../config/publicShellConfig';
import TenantWordmark from '../brand/TenantWordmark';
import SocialMediaIcons from '../common/SocialMediaIcons';

function formatPublicAddress(contact) {
  const address = contact?.address;
  if (!address) return '';

  const cityState = [address.city, address.state].filter(Boolean).join(', ');
  if (contact.showAddressPublicly) {
    return [
      address.streetAddress,
      address.addressLine2,
      [cityState, address.postalCode].filter(Boolean).join(' '),
      address.country,
    ].filter(Boolean).join(', ');
  }

  return cityState;
}

function Footer() {
  const { tenant, spotlightName, tenantLogoConfig, tenantLogoImageUrl } = usePublicTenant();
  const navigate = useNavigate();

  const footerLogoUrl = getTenantLogoUrl(tenant, 'onDark') || tenantLogoImageUrl;
  const resolvedFooterLogo = {
    alt: `${spotlightName} logo`,
    ...(footerLogoUrl
      ? { src: footerLogoUrl }
      : {
          element: (
            <TenantWordmark
              cityName={tenantLogoConfig?.cityName || spotlightName}
              cityColor="var(--primary-foreground)"
              labelColor="var(--primary-foreground)"
            />
          ),
        }),
  };

  const footerConfig = buildPublicFooterConfig({
    spotlightName,
    logo: resolvedFooterLogo,
    contactInfo: {
      email: tenant?.websiteContact?.contactEmail || '',
      phone: tenant?.websiteContact?.contactPhone || '',
      address: formatPublicAddress(tenant?.websiteContact),
    },
    socialContent: (
      <SocialMediaIcons
        links={tenant?.socialLinks || []}
        size="sm"
        variant="footer"
        labelPrefix={`Visit ${spotlightName} on`}
      />
    ),
    navigationItems: tenant?.websiteNavigationItems || [],
  });

  const handleNavigate = (href) => {
    if (!href || href === '#') {
      return;
    }

    if (href.startsWith('/')) {
      navigate(href);
      return;
    }

    window.location.assign(href);
  };

  return <PublicFooter id="contact" {...footerConfig} onNavigate={handleNavigate} />;
}

export default Footer;
